import {TableSettings} from "../../../tableSettings";

export const oceanExportMblList:TableSettings = {
  tableVersion: 10056,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: []
};

export const oceanExportHblList:TableSettings = {
  tableVersion: 10062,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: []
};

export const hblBlDetailsHblBody: TableSettings = {
  tableVersion: 1008,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '170px',
  headersColor: 'white',
  useStorage: true,
  flexResizer: true,

  columns: [
    {
      Header: 'Billing Code',
      accessor: 'chgCodeName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 20.56,
    },
    {
      Header: 'Item Description',
      accessor: 'description',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 29.1,
    },
    {
      Header: 'Revenue',
      accessor: 'preRevenue',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.33,
    },
    {
      Header: 'Cost',
      accessor: 'preCost',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.33,
    },
    {
      Header: 'Revenue',
      accessor: 'colRevenue',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.33,
    },
    {
      Header: 'Cost',
      accessor: 'colCost',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.33,
    },
    {
      Header: 'A',
      accessor: 'agentShow',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.07,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.08,
    },
  ]
};

export const oceanExportQuotationList:TableSettings = {
  tableVersion: 10048,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'status', Header: 'S', visible: true, width: 30, canBeHidden: false, resizable: false, sortable: false },
    { accessor:'quoteDate', Header: 'Date', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'quoteNo', Header: 'Quotation #', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true },
    { accessor:'operator', Header: 'Quote By', visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'validBy', Header: 'Valid By', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'sName', Header: 'Customer', visible: true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'contactName', Header: 'Contact', visible: true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text',  },
    { accessor:'hBookingNo', Header: 'Booking #', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'serviceType', Header: 'Move Type', visible:true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'commodity', Header: 'Commodity', visible:true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'plofRec', Header: 'Place of Receipt', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'lPort', Header: 'Loading Port', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'discharge', Header: 'Discharge Port', visible: true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'plofDel', Header: 'Place of Delivery', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'finalDest', Header: 'Final Destination', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'sManID', Header: 'Salesperson', visible:true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'u2Date', Header: 'Update', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'u2ID', Header: 'Update by', visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'u1ID', Header: 'Create by', visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
  ]
};

export const oceanExportLoadPlanList:TableSettings = {
  tableVersion: 10046,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'status', Header: 'S', visible: true, width: 30, canBeHidden: false, resizable: false, sortable: false },
    { accessor:'containerNo', Header: 'Container #', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true },
    { accessor:'conType', Header: 'Type', visible: true, width: 60, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'refNo', Header: 'Ref. #', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'bookingNo', Header: 'Booking #', visible: true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'mblNo', Header: 'MBL #', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'agentSName', Header: 'Agent Name', visible: true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'cutOffDate', Header: 'Cargo Cutoff', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'vessel', Header: 'Vessel Name', visible: true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'voyage', Header: 'Voyage #', visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'loadingPort', Header: 'Loading Port', visible: true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'etd', Header: 'ETD', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'lpU2Date', Header: 'Update', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'lpU2ID', Header: 'Update by', visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'u1ID', Header: 'Create by', visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
  ]
};

export const hblBlDetailsNoOfPackages:TableSettings = {
  tableVersion: 1009,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '94px',
  headersColor: 'white',
  useStorage: true,
  flexResizer: true,

  columns: [
    {
      Header: 'Container #',
      accessor: 'containerNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 22.22,
    },
    {
      Header: 'Type',
      accessor: 'conType',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 19.44,
    },
    {
      Header: 'Seal #',
      accessor: 'sealNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 19.44,
    },
    {
      Header: 'Pkg(s)',
      accessor: 'pkgs',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 19.44,
    },
    {
      Header: 'Select', // Here: 여기에 아이콘이 들어가야함.
      accessor: 'agentShow',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 13.88,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.55,
    },
  ]
};

export const hblBlDetailsDimensions:TableSettings = {
  tableVersion: 1005,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '94px',
  headersColor: 'white',
  useStorage: true,
  flexResizer: true,

  columns: [
    {
      Header: 'Length',
      accessor: 'length',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15.27,
    },
    {
      Header: 'Width',
      accessor: 'width',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15.27,
    },
    {
      Header: 'Height',
      accessor: 'height',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15.27,
    },
    {
      Header: 'Pkgs',
      accessor: 'pcs',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15.27,
    },
    {
      Header: 'CBM',
      accessor: 'chgWeight',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 16.66,
    },
    {
      Header: 'Act.Wt(lbs)',
      accessor: 'lChgWeight',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 16.66,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.10,
    },
  ]
};

export const loadPlanDetails:TableSettings = {
  tableVersion: 1006,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '400px',
  headersColor: 'gray',
  useStorage: true,
  flexResizer: true,

  columns: [
    {
      Header: '',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.55,
    },
    {
      Header: 'H.Booking #',
      accessor: 'hBookingNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.51,
    },
    {
      Header: 'Shipper',
      accessor: 'shipperName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 27.77,
    },
    {
      Header: 'PKG',
      accessor: 'pkgs',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 14.81,
    },
    {
      Header: 'LBS',
      accessor: 'lbs',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 14.81,
    },
    {
      Header: 'CBM',
      accessor: 'cbm',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 14.81,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.37,
    },
  ]
};

export const oceanExportBookingList:TableSettings = {
  tableVersion: 10048,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'status', Header: 'S', visible: true, width: 30, canBeHidden: false, resizable: false, sortable: false },
    { accessor:'bookDate', Header: 'Date', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'hBookingNo', Header: 'Cust. Book. Rqst #', visible:true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true },
    { accessor:'bookedBy', Header: 'Book By', visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'custName', Header: 'Customer', visible: true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'custContact', Header: 'Contact', visible: true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'consignee', Header: 'Consignee', visible: true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'agentName', Header: 'Agent', visible: true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'quoteNo', Header: 'Quotation #', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: false, filterType: 'text' },
    { accessor:'hblNo', Header: 'HBL #', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'refNo', Header: 'Ref. #', visible:true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'confirmed', Header:'Book CFM', visible: true, width:75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType:'text'},
    { accessor:'cBookingNo', Header: 'Carrier\'s Book #', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text',  },
    { accessor:'portCutOff', Header: 'Cargo Cutoff', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'railCutOff', Header: 'SED Cutoff', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'conType', Header: 'CNTR Type/Qty', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    // { accessor:'pkgs', Header: 'Qty', visible:true, width: 50, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'moveType', Header: 'Move Type', visible:true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'commodity', Header: 'Commodity', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'vessel', Header: 'Vessel Name', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'voyage', Header: 'Voyage #', visible:true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'loadingPort', Header: 'Loading Port', visible: true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'bookEtd', Header: 'ETD', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'disCharge', Header: 'Discharge Port', visible: true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'bookEta', Header: 'ETA', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'plofRec', Header: 'Place of Receipt', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'plofDel', Header: 'Place of Delivery', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'finalDest', Header: 'Final Destination', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'truckingCompany', Header: 'Trucking Company', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    // { accessor:'puEmptyLoc', Header: 'P/U Empty Container', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'puCargoLocation', Header: 'P/U Cargo Location', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'bookRemark', Header: 'Export Ref. #', visible:true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'exPref', Header: 'Remark', visible:true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'createDate', Header: 'Create', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'u1ID', Header: 'Create by', visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'u2Date', Header: 'Update', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'u2ID', Header: 'Update by', visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
  ]
};

export const oeQuotationBillingInfo:TableSettings = {
  tableVersion: 10049,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '240px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.41,
    },
    {
      Header: 'Charge Description',
      accessor: 'chargeDesc',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 35.23,
    },
    {
      Header: 'Unit',
      accessor: 'unit',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.09,
    },
    {
      Header: 'Qty',
      accessor: 'qty',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.09,
    },
    {
      Header: 'Buying Rate',
      accessor: 'buying',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.09,
    },
    {
      Header: 'Selling Rate',
      accessor: 'selling',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.09,
    },
    {
      Header: 'Buying Amount',
      accessor: 'tBuying',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.36,
    },
    {
      Header: 'Selling Amount',
      accessor: 'tSelling',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.36,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.27,
    },
  ]
};

export const otQuotationBillingInfo:TableSettings = {
  tableVersion: 10048,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '240px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.45,
    },
    {
      Header: 'Charge Description',
      accessor: 'chargeDesc',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 34.48,
    },
    {
      Header: 'Unit',
      accessor: 'unit',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.20,
    },
    {
      Header: 'Qty',
      accessor: 'qty',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.20,
    },
    {
      Header: 'Buying Rate',
      accessor: 'buyRate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.20,
    },
    {
      Header: 'Selling Rate',
      accessor: 'sellRate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.20,
    },
    {
      Header: 'Buying Amount',
      accessor: 'tBuying',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.49,
    },
    {
      Header: 'Selling Amount',
      accessor: 'tSelling',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.49,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.29,
    },
  ]
};

export const oeMblContainerDetails:TableSettings = {
  tableVersion: 1008,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '120px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'white',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.05,
    },
    {
      Header: 'Container #',
      accessor: 'containerNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.81,
    },
    {
      Header: 'Type',
      accessor: 'conType',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.81,
    },
    {
      Header: 'Seal #',
      accessor: 'sealNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.81,
    },
    {
      Header: 'Pkg(s)',
      accessor: 'pkgs',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.81,
    },
    {
      Header: 'Unit',
      accessor: 'pUnit',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.10,
    },
    {
      Header: 'Weight (KGS)',
      accessor: 'gKgs',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.16,
    },
    {
      Header: 'Weight (LBS)',
      accessor: 'gLbs',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.16,
    },
    {
      Header: 'Flexi Tank',
      accessor: 'isFlexiTank',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.10,
    },
    {
      Header: 'Tank Serial #',
      accessor: 'serialNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.45,
    },
    /*{
      Header: 'Del',
      accessor: 'commands',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage:3.66,
    },*/
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.70,
    },
  ]
};

export const oeMblContainerDetailsNoFlexiTank:TableSettings = {
  tableVersion: 1008,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '120px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'white',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.05,
    },
    {
      Header: 'Container #',
      accessor: 'containerNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 28.36,
    },
    {
      Header: 'Type',
      accessor: 'conType',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.81,
    },
    {
      Header: 'Seal #',
      accessor: 'sealNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.81,
    },
    {
      Header: 'Pkg(s)',
      accessor: 'pkgs',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.81,
    },
    {
      Header: 'Unit',
      accessor: 'pUnit',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.10,
    },
    {
      Header: 'Weight (KGS)',
      accessor: 'gKgs',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.16,
    },
    {
      Header: 'Weight (LBS)',
      accessor: 'gLbs',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.16,
    },
    /*{
      Header: 'Del',
      accessor: 'commands',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage:3.66,
    },*/
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.70,
    },
  ]
};

export const hblOeHblPoBodyLineItems:TableSettings = {
  tableVersion: 1004,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '380px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.67,
    },
    {
      Header: 'Container #',
      accessor: 'containerNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.92,
    },
    {
      Header: 'SKU/Product Code',
      accessor: 'skuNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.71,
    },
    {
      Header: 'Description',
      accessor: 'description',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 13.39,
    },
    {
      Header: 'Qty',
      accessor: 'shipQty',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.92,
    },
    {
      Header: 'Unit',
      accessor: 'shipUnit',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.14
    },
    {
      Header: 'Unit Price',
      accessor: 'uPrice',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.14,
    },
    {
      Header: 'KGS',
      accessor: 'kgs',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.92,
    },
    {
      Header: 'LBS',
      accessor: 'lbs',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.92,
    },
    {
      Header: 'P.O #',
      accessor: 'poNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.14,
    },
    {
      Header: 'HTS Code',
      accessor: 'htsCode',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.14,
    },
    {
      Header: 'C. Origin',
      accessor: 'coo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.14,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.78,
    },
  ]
};


/* More popups */

export const bookingPickupDeliveryTable:TableSettings = {
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '150px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'Trucking Vendor',
      accessor: 'truckingVendor',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15,
    },
    {
      Header: 'Pickup Ref. #',
      accessor: 'pickupRefNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15,
    },
    {
      Header: 'Pickup Date',
      accessor: 'pickupDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15,
    },
    {
      Header: 'Pickup At',
      accessor: 'pickupAt',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15,
    },
    {
      Header: 'Delivery Date',
      accessor: 'deliveryDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15,
    },
    {
      Header: 'Delivery To',
      accessor: 'deliveryTo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15,
    },
    {
      Header: 'User',
      accessor: 'user',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10,
    },
  ]
};

export const batchPrintTable:TableSettings = {
  tableVersion: 10047,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '222px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '',
      accessor: 'selected',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5,
    },
    {
      Header: 'HBL #',
      accessor: 'hblNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 20,
    },
    {
      Header: 'Customer',
      accessor: 'customerName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 46.66,
    },
    {
      Header: 'Broker',
      accessor: 'brokerName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 25,
    },
    { 
      Header: '', 
      accessor: 'scroll', 
      resizable: false, 
      sortable: false, 
      visible: true, 
      initialWidthPercentage: 3.33, 
    },
  ]
};

export const containerLoadPlanTable:TableSettings = {
  tableVersion: 1009,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '150px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    { Header: 'House Booking #', accessor: 'hbookingno', resizable: false, sortable: false, visible: true, initialWidthPercentage: 16.17, },
    { Header: 'Doc Receipt #', accessor: 'doC_RECEIPTNO', resizable: false, sortable: false, visible: true, initialWidthPercentage: 14.7, },
    { Header: 'Qty', accessor: 'pkgs', resizable: false, sortable: false, visible: true, initialWidthPercentage: 11.76, },
    { Header: 'LBS', accessor: 'lbs', resizable: false, sortable: false, visible: true, initialWidthPercentage: 11.76, },
    { Header: 'CBM', accessor: 'cbm', resizable: false, sortable: false, visible: true, initialWidthPercentage: 11.76, },
    { Header: 'Final Destination', accessor: 'finalDest', resizable: false, sortable: false, visible: true, initialWidthPercentage: 14.7, },
    { Header: 'Shipper', accessor: 'shipperName', resizable: false, sortable: false, visible: true, initialWidthPercentage: 16.17, },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.94, },]
};

export const commercialInvoiceTable:TableSettings = {
  tableVersion: 10016,
  overflowX: 'hidden',
  overflowY: 'hidden',
  
  height: '300px',
  useStorage: false,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'Mark and Numbers',
      accessor: 'mark',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 25,
    },
    {
      Header: 'Qty',
      accessor: 'markPkg',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15,
    },
    {
      Header: 'Description of Packages and Goods',
      accessor: 'description',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 30,
    },
    {
      Header: 'Unit Price',
      accessor: 'unitPrice',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15,
    },
  ]
};

export const packingListTable:TableSettings = {
  tableVersion: 1006,
  overflowX: 'hidden',
  overflowY: 'hidden',
  
  height: '300px',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  columns: [
    {
      Header: 'Mark and Numbers',
      accessor: 'mark',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 25,
    },
    {
      Header: 'Qty',
      accessor: 'markPkg',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15,
    },
    {
      Header: 'Description of Packages and Goods',
      accessor: 'description',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 30,
    },
    {
      Header: 'Weight',
      accessor: 'markGross',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15,
    },
    {
      Header: 'Measurement',
      accessor: 'markMeasure',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15,
    },
  ]
};

export const oceanExportContainerStatusList:TableSettings = {
  tableVersion: 1008,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'status', Header: 'S', visible: true, width: 30, canBeHidden: false, resizable: false, sortable: false },
    { accessor:'containerNo', Header: 'Container N#', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true },
    { accessor:'ft', Header: 'FT', visible: true, width: 40, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'conType', Header: 'Type', visible: true, width: 60, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'refNo', Header: 'Ref. #', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'pickupNo', Header: 'Pickup #', visible: true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'sealNo', Header: 'Seal #', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },

    { accessor:'inDate', Header: 'Gate In', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'outDate', Header: 'Gate Out', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'emptryReturn', Header: 'Empty Return', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'ord', Header: 'Origin', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'atd', Header: 'ATD', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'rAtd', Header: 'Rail ATD', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'rAta', Header: 'Rail RTA', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'puDate', Header: 'Pickup Date', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    // { accessor:'dcDate', Header: 'Deliver Date', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'pkgs', Header: 'Pkgs', visible: true, width: 60, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'kgs', Header: 'KGS', visible: true, width: 60, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'lbs', Header: 'LBS', visible: true, width: 60, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'number' },
    { accessor:'mblNo', Header: 'MBL #', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'vessel', Header: 'Vessel Name', visible: true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'voyage', Header: 'Voyage #', visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'eta', Header: 'ETA', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
  ]
};
